const React = require('react');
const { ThemeProvider } = require('./src/contexts/ThemeContext');

exports.wrapRootElement = ({ element }) => (
    <ThemeProvider>{element}</ThemeProvider>
);
